import { createAPI } from '../../common'
// MediaCloudAppPermission
export default {
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efubjm0tubuvt', 'get', config)
}
